import type { RouteRecordRaw } from 'vue-router'
import { AppRoute } from '@/constants'
import { Administration } from '@/constants/rights'

export const StatisticRoutes: RouteRecordRaw[] = [
  {
    path: AppRoute.Statistic.path,
    name: AppRoute.Statistic.name,
    component: () => import('@/modules/statistic/Index.vue'),
    meta: {
      requiresAuth: true,
      authorities: [Administration],
    },
  },
]
